export { WishlistButton, type WishlistButtonProps } from "./WishlistButton";
